import React from 'react';
import './Page.css';

const Services: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/services.jpg')" }}>
        <h1 className="animate-fade-up">Services</h1>
        <p className="hero-subtitle animate-fade-up delay-100">Comprehensive Accounting and Business Solutions</p>
      </div>
      <div className="page-content">
        <section className="content-section">
          <h2 className="animate-fade-up">Our Professional Services</h2>
          <div className="services-grid">
            <div className="service-card animate-fade-up delay-100">
              <h3>Virtual CFO</h3>
              <p>Strategic financial leadership for your business growth</p>
              <ul>
                <li>Financial planning and analysis</li>
                <li>Cash flow management</li>
                <li>Strategic business advice</li>
                <li>Performance monitoring</li>
              </ul>
            </div>
            <div className="service-card animate-fade-up delay-200">
              <h3>Tax Filing and Planning</h3>
              <p>Expert tax services to optimize your tax position</p>
              <ul>
                <li>Tax return preparation</li>
                <li>Tax planning strategies</li>
                <li>GST registration and compliance</li>
                <li>Tax structure advice</li>
              </ul>
            </div>
            <div className="service-card animate-fade-up delay-300">
              <h3>Inventory Management Consulting</h3>
              <p>Optimize your inventory processes for better profitability</p>
              <ul>
                <li>Inventory system setup</li>
                <li>Stock control procedures</li>
                <li>Cost analysis</li>
                <li>Performance optimization</li>
              </ul>
            </div>
            <div className="service-card animate-fade-up delay-400">
              <h3>Business Advice</h3>
              <p>Strategic guidance aligned with your business goals</p>
              <ul>
                <li>Business planning</li>
                <li>Growth strategies</li>
                <li>Financial advice</li>
                <li>Risk management</li>
              </ul>
            </div>
            <div className="service-card animate-fade-up delay-500">
              <h3>Cloud Accounting</h3>
              <p>Modern accounting solutions for the digital age</p>
              <ul>
                <li>Xero implementation</li>
                <li>MYOB setup and training</li>
                <li>Real-time reporting</li>
                <li>Mobile access</li>
              </ul>
            </div>
            <div className="service-card animate-fade-up delay-600">
              <h3>Bookkeeping Services</h3>
              <p>Accurate and timely financial record keeping</p>
              <ul>
                <li>Daily transaction recording</li>
                <li>Bank reconciliations</li>
                <li>Financial statements</li>
                <li>Payroll processing</li>
              </ul>
            </div>
          </div>
        </section>
        <section className="content-section animate-fade-up delay-300">
          <h2>Free Business Resources</h2>
          <p>We provide free tools and resources to help you grow and manage your business effectively.</p>
        </section>
      </div>
    </div>
  );
};

export default Services;
